import controller from '../../Controller.js';
import { styles, getMarkerImage } from './Styles.js';
import loadScript from '../../Util/loadScript.js';

function Map(container) {
    var map;
    var markers = [];
    var cluster;
    var zoom;
    var defaultCenter = { lat: 62.9, lng: 15.6 }

    var mapsScript = "https://maps.googleapis.com/maps/api/js?v=3.2.1&key=" + container.dataset.apiKey;
    var scripts = [
        "/resources/scripts/googlemaps_infobox_packed.js",
        "/resources/scripts/googlemaps_markerclusterer_packed.js"];

    function init() {

        this.isInitialized = false;

        zoom = Number(container.dataset.zoom);

        var loading = container.dataset.loading || "eager";

        if (loading === "lazy") {
            this.observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (!this.isInitialized && entry.isIntersecting) {
                        this.isInitialized = true;
                        this.observer.unobserve(container);
                        loadScript(mapsScript)
                            .then(() => loadScript(...scripts)
                                .then(() => loadMap(container)));
                    }
                });
            });

            this.observer.observe(container);

        }
        else {
            loadScript(mapsScript)
                .then(() => loadScript(...scripts)
                    .then(() => loadMap()));
        }

        
    }

    function loadMap() {
        const json = JSON.parse(container.getAttribute('data-markers'));

        map = new google.maps.Map(container, {
            zoom: zoom || 5,
            styles: styles,
            scrollwheel: false,
            mapTypeControl: false
        });

        console.log("zoom", zoom)

        if (zoom && json.length > 0) {
            
            const bounds = setMarkers(map, json);
            map.setCenter(bounds.getCenter());
            map.setZoom(zoom);
        }
        else if (json.length > 0) {
            const bounds = setMarkers(map, json);
            map.fitBounds(bounds);
        }
        else {
            map.setCenter(defaultCenter);
        }

        var listener = google.maps.event.addListener(map, "idle", function () {
            if (map.zoom > 20) {
                map.setZoom(15);
            }
        });
    }

    function update(json) {
        removeMarkers();
        if (json.length > 0) {
            const bounds = setMarkers(map, json);
            map.fitBounds(bounds);
        }
        else {
            map.setCenter(defaultCenter);
            map.setZoom(5);
        }
    }

    function setMarkers(map, json) {
        var bounds = new google.maps.LatLngBounds();
        var infobox = new InfoBox({
            disableAutoPan: false,
            maxWidth: 150,
            pixelOffset: new google.maps.Size(-120, -45),
            zIndex: null,
            boxStyle: { width: "240px" },
            closeBoxURL: "/resources/images/cross-gray.svg",
            infoBoxClearance: new google.maps.Size(1, 1),
            alignBottom: true
        });

        json.forEach((entry) => {
            var marker = new google.maps.Marker({
                position: { lat: entry.coordinates.latitude, lng: entry.coordinates.longitude },
                map: map,
                icon: getMarkerImage(google)
            });

            markers.push(marker);

            marker.addListener('click', function () {
                infobox.close();
                infobox.setContent(setInfoboxContent(entry));
                infobox.open(map, this);
            });

            bounds.extend(marker.position);
        });
        createClusters();
        return bounds;
    }

    function createClusters() {
        var clusterOptions = {
            gridSize: 25,
            styles: [{
                url: '/resources/images/m1.png',
                width: 45,
                height: 45,
                textSize: 20,
                anchor: [10, 0],
                textColor: '#ffffff'
            }]
        };
        cluster = new MarkerClusterer(map, markers, clusterOptions);
    }

    function removeMarkers() {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers = [];
        if (cluster) {
            cluster.clearMarkers();
        }
    }

    function setInfoboxContent(entry) {
        return `
      <div class="infobox">
        <strong class="infobox__title${entry.smallTitle ? ' infobox__title--small' : ''}">
          ${entry.titleLink ? `<a href="${entry.titleLink}">${entry.title}</a>` : entry.title}
        </strong>
        <div class="infobox__body">
          ${entry.htmlBody}
        </div>
      </div>
    `;
    }

    return {
        init: init,
        update: update
    }
}

controller.add('Map', Map);

export default Map;
